import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import ImageDataPod from '../../../components/ImageDataPod';
import logo from './cbca@2x.png';

const messages = defineMessages({
  commonBlackCollegeApp: {
    id: 'hubs.admissions.commonBlackCollegeApp',
    defaultMessage: 'Common Black College App',
  },
  text: {
    id: 'hubs.admissions.commonBlackCollegeApp.text',
    defaultMessage: 'This school accepts the Common Black College App',
  },
  linkText: {
    id: 'hubs.admissions.commonBlackCollegeApp.linktext',
    defaultMessage: 'Learn more and start your application on the CBCA website',
  },
});

const CommonBlackCollegeApp = ({ intl }) => {
  const title = intl.formatMessage(messages.commonBlackCollegeApp);

  return (
    <ImageDataPod
      header={title}
      content={{
        eduLogoSrc: logo,
        eduLogoAlt: 'Common Black College App Logo',
        eduLogoWidth: 132,
        text: intl.formatMessage(messages.text),
        linkText: intl.formatMessage(messages.linkText),
        linkUrl: 'https://commonblackcollegeapp.com/',
      }}
    />
  );
};

CommonBlackCollegeApp.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(CommonBlackCollegeApp);
